import { Controller } from "@hotwired/stimulus"

// Shows or hides a target element based on a source field's value.
//
// Usage:
//   data-controller="conditional-field"
//   data-conditional-field-show-when-value="yes"
//
//   Source element: data-conditional-field-target="source"
//   Target element: data-conditional-field-target="target"
//
// When the source field's value matches showWhen, the target is revealed;
// otherwise it is hidden.
export default class extends Controller {
  static targets = ["source", "target"]
  static values = { showWhen: String }

  connect() {
    this.#evaluate()
  }

  sourceTargetConnected() {
    this.#evaluate()
  }

  onChange() {
    this.#evaluate()
  }

  #evaluate() {
    if (!this.hasSourceTarget || !this.hasTargetTarget) return
    const show = this.#sourceValue() === this.showWhenValue
    this.targetTarget.hidden = !show
  }

  #sourceValue() {
    const source = this.sourceTarget
    if (source.type === "radio" || source.type === "checkbox") {
      const name = source.name
      const checked = this.element.querySelector(`[name="${name}"]:checked`)
      return checked ? checked.value : ""
    }
    return source.value
  }
}
